module.exports = __webpack_public_path__ + "Lato-BlackItalic.0f4fa9755f480e75463e.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-BlackItalic.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-BlackItalic.woff2
// module chunks = styles